import { useState } from 'react'
import { Appointment } from '@apis'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const useAppointmentActions = ({ selector }) => {
  const initialAlertInfo = {
    type: '',
    id: '',
    status: '',
  }
  const [alertInfo, setAlertInfo] = useState(initialAlertInfo)
  const [loading, setLoading] = useState<boolean>(false)
  const [visible, setVisible] = useState<boolean>(false)
  const { data: user } = useSelector((state: any) => state.user)
  const navigate = useNavigate()
  const handleClickBtn = async (event) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-type]')
    if (!!cross) {
      const attribute = cross.getAttribute('data-cross-type')
      const splitAttribute = attribute.split('-')

      switch (splitAttribute[0]) {
        case 'reschedule':
          setAlertInfo({
            type: splitAttribute[0],
            id: splitAttribute[1],
            status: '',
          })
          setVisible(true)
          break
        case 'confirm':
          setAlertInfo({
            type: splitAttribute[0],
            id: splitAttribute[1],
            status: 'Confirmed',
          })
          setVisible(true)
          break
        case 'complete':
          setAlertInfo({
            type: splitAttribute[0],
            id: splitAttribute[1],
            status: 'Completed',
          })
          setVisible(true)
          break
        case 'view':
          navigate(`/${user?.role}/appointments/details-${splitAttribute[1]}`)
          break
        case 'message':
          const splitReceiver = cross.getAttribute('data-receiver').split('-')
          const receiver = {
            id: splitReceiver[0],
            name: splitReceiver[1],
            avatar: splitReceiver[2],
          }
          navigate(`/${user?.role}/chats`, {
            state: {
              receiver,
            },
          })
          break
        case 'cancel':
          setAlertInfo({
            type: splitAttribute[0],
            id: splitAttribute[1],
            status: 'Cancelled',
          })
          setVisible(true)
          break
      }
    }
  }

  const handleClose = () => {
    setVisible(false)
    setAlertInfo(initialAlertInfo)
  }

  const handleClickYes = async () => {
    setLoading(true)
    await Appointment.updateStatus({
      data: {
        status: alertInfo?.status,
      },
      id: alertInfo?.id,
      state: selector,
      action: 'update',
    })
      .then(() => {
        setVisible(false)
      })
      .catch(() => {})
    setLoading(false)
  }
  return {
    handleClickBtn,
    handleClickYes,
    handleClose,
    alertInfo,
    loading,
    visible,
  }
}

export default useAppointmentActions
